import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import api, { apiAction } from '../../../api'
import getActions from './actions'
import { Button, Loading } from '../../../components'

import Item from './item'
import S from './styled'

import {
  fetchItems as fetchItemsAction,
  addItem as addItemAction,
  deleteItem as deleteItemAction,
  updateItem as updateItemAction,
} from './storeActions'

const defaultItem = { translates: {} }

const UsersEditor = props => {
  const {
    fetchItems, items,
    isLoading,
  } = props

  useEffect(() => {
    (async () => {
      await fetchItems()
    })()
  }, [fetchItems])

  const [showNew, setShowNew] = useState(true)

  const { onAdd, onDelete, onSave } = getActions({ ...props, setShowNew })

  const onCancelNew = () => setShowNew(true)

  return isLoading ? <Loading overlay/> : (
    <div>
      <S.List>
        {items.map((item, index) => (
          <Item {...{ item, key: item.userId, onDelete, onSave,
          }} />
        ))}
      </S.List>
      {showNew ?  (
        <Button blue onClick={() => setShowNew(false)} > Add </Button>
      ) : (
        <Item {...{
          item: defaultItem, onSave: onAdd, isNew: true, onCancelNew,
        }} />
      )}
    </div>
  )
}

UsersEditor.propTypes = {
  items: PropTypes.array,
}

const mapStateToProps = state => ({
  items: state.users.list,
  isLoading: state.users.isLoading,
})

const mapDispatchToProps = dispatch => ({
  fetchLocales: () => dispatch(apiAction(api.getLocales)()),
  fetchItems: () => dispatch(fetchItemsAction()),
  addItem: item => dispatch(addItemAction(item)),
  deleteItem: entityId => dispatch(deleteItemAction(entityId)),
  updateItem: (entityId, item) => dispatch(updateItemAction(entityId, item)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UsersEditor)
